import httpRequest from '@/api/request'
import {
  I_StatsData,
  I_regionList,
  I_BlockAverageBlockTime,
  RegionDetailData,
  GetRegionDetailStakingTrendParams,
  StatisticNew_Response,
  Region_List_Response,
} from './types'

/**
 * 区总的质押统计信息 statistic
 * @param params
 * @returns
 */
export const getRegionStatistic = (params = {}): Promise<I_StatsData> => {
  return httpRequest.get('/api/rest/region/statistic', { params })
}

/**
 * 所有区总的质押统计信息 statistic
 * @param params
 * @returns
 */
export const getRegionStatisticNew = (params = {}): Promise<StatisticNew_Response> => {
  return httpRequest.get('/api/region/statistic', { params })
}

/**
 * 查询平均出块时间（按小时统计）和最新区块高度
 * @param params
 * @returns
 */
export const getBlockAverageBlockTime = (params = {}): Promise<I_BlockAverageBlockTime> => {
  return httpRequest.get('/api/rest/block/average-block-time', { params })
}

/**
 * 查询区域列表 list
 * @param params
 * @returns
 */
export const getBlockTransactionList = (params?: { [key: string]: any }): Promise<I_regionList> => {
  return httpRequest.get('/api/rest/region/list', { ...params })
}

/**
 * 查询区域列表 list
 * @param params
 * @returns
 */
export const getRegionList = (
  params: { [key: string]: any } = {},
): Promise<Region_List_Response> => {
  return httpRequest.get('/api/region/list', { params })
}

/**
 * 区域详情 detail
 * @param params
 * @returns
 */
export const getRegionDetail = (params: { region_id: string }): Promise<RegionDetailData> => {
  return httpRequest.get('/api/region/detail', { params })
}

/**
 * 区质押趋势 stakingTrend
 * @param params
 * @returns
 */
export const getRegionDetailStakingTrend = (
  params: GetRegionDetailStakingTrendParams,
): Promise<any> => {
  return httpRequest.post('/api/rest/region/staking-trends', { ...params })
}
